import * as Yup from "yup";

export const otpCodeSchema = Yup.object().shape({
  otp: Yup.string().length(6, "Must be exactly 6 digits").required("Required"),
});

export const getEmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});
